/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboGetawsauthchecksetupstatusGetAWSAuthCheckSetupStatusResult
 */
export interface JumboGetawsauthchecksetupstatusGetAWSAuthCheckSetupStatusResult {
    /**
     * 
     * @type {boolean}
     * @memberof JumboGetawsauthchecksetupstatusGetAWSAuthCheckSetupStatusResult
     */
    isSetupComplete?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JumboGetawsauthchecksetupstatusGetAWSAuthCheckSetupStatusResult
     */
    userAccountID?: string;
}

/**
 * Check if a given object implements the JumboGetawsauthchecksetupstatusGetAWSAuthCheckSetupStatusResult interface.
 */
export function instanceOfJumboGetawsauthchecksetupstatusGetAWSAuthCheckSetupStatusResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetawsauthchecksetupstatusGetAWSAuthCheckSetupStatusResultFromJSON(json: any): JumboGetawsauthchecksetupstatusGetAWSAuthCheckSetupStatusResult {
    return JumboGetawsauthchecksetupstatusGetAWSAuthCheckSetupStatusResultFromJSONTyped(json, false);
}

export function JumboGetawsauthchecksetupstatusGetAWSAuthCheckSetupStatusResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetawsauthchecksetupstatusGetAWSAuthCheckSetupStatusResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isSetupComplete': !exists(json, 'isSetupComplete') ? undefined : json['isSetupComplete'],
        'userAccountID': !exists(json, 'userAccountID') ? undefined : json['userAccountID'],
    };
}

export function JumboGetawsauthchecksetupstatusGetAWSAuthCheckSetupStatusResultToJSON(value?: JumboGetawsauthchecksetupstatusGetAWSAuthCheckSetupStatusResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isSetupComplete': value.isSetupComplete,
        'userAccountID': value.userAccountID,
    };
}

